import { linkAssemblers } from "@/lib/unified-dtos/unified-media-mapper/helpers";

import { SweetOrHotLadiesDTO, SweetOrHotLadiesDTORaw } from "../models";

export const mapData = (data: SweetOrHotLadiesDTORaw): SweetOrHotLadiesDTO => {
  return {
    requestDTO: {
      ...data.requestDTO,
      dataMap: {
        ...data.requestDTO.dataMap,
        result: data.requestDTO.dataMap.result.map((lady) => ({
          ...lady,
          photoSrcs: {
            small: linkAssemblers.safeMakePhotoThumbnailSmall({
              mediaName: lady.mainPhotoDTO?.mediaName,
            }),
            medium: linkAssemblers.safeMakePhotoThumbnailMedium({
              mediaName: lady.mainPhotoDTO?.mediaName,
            }),
            large: linkAssemblers.safeMakePhotoUrl({
              mediaName: lady.mainPhotoDTO?.mediaName,
            }),
          },
        })),
      },
    },
  };
};
